import * as React from 'react';

import Box from '@mui/material/Box';

import AppPage from '@/ui/AppPage/AppPage';

import Permissions from '@/lib/permissions';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import POI from '@/models/pristupacnost/poi';
import Grading from '@/models/pristupacnost/grading';

const POIPage = () => (
  <AppPage needPermission={[Permissions.PristupacnostCore]} titlett="pristupacnost:titles.evaluacija_objekata">
    <Box m={0} style={{ height: '100%' }}>
      <DataCentricPage
        primaryModel={POI}
        primaryTitleToken="pristupacnost:titles.poi"
        primaryView="default"
        secondaryModel={Grading}
        secondaryTitleToken="pristupacnost:titles.grades"
        secondaryView="default"
        baseRecordPath={POI.apiPath}
        childRecordRelativePath="grades"
        geomRelativePath=""
        mapId={85}
        mapModel={POI}
        allowMinimapHideObjects
      />
    </Box>
  </AppPage>
);

export default POIPage;
